import PromoHeader from './PromoHeader';

export default PromoHeader;
